module.exports = __webpack_public_path__ + "img/plusIcon.1f0e3336.svg";